import React from "react";
import "./App.css";

import "./App.css";
import Header from "./components/Header/Header";
import { Route,BrowserRouter as Router, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Reviews from "./pages/Reviews/Reviews";
import Footer from "./components/Footer/Footer";
import Login from "./pages/Login/Login";
import BookNow from "./components/Book Now/BookNow";
function App() {
  return (
    <>
     <Router>
     <Header />
      <Routes>
        <Route path="/" element={<Home/>}></Route>
        <Route path="/about" element={<About/>}></Route>
        <Route path="/contact" element={<Contact/>}></Route>
        <Route path="/login" element={<Login/>}/>
        <Route path="/Reviews" element={<Reviews/>}></Route>
        <Route path="/BookNow" element={<BookNow/>}></Route>
      </Routes>
      <Footer/>
     </Router>
        
      
    </>
  );
}

export default App;
